import Component from '../Component';
import Element from '../../Prototype/UI/Element';

export default class UIComponent extends Component<PIXI.ui.Element, Element> {
    public UIComponent: PIXI.ui.component.IComponent;
}
